import {Component, Input, OnInit} from '@angular/core';
import {
  FormArray,
  FormControl,
  FormGroup,
  UntypedFormControl,
  UntypedFormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import {nodemailerEmailValidator} from '../../../../shared/shared-utils/form/email.validator';
import {GetInputAlertOptions} from '../../../../shared-utilities/services-old/standard-alerts.service';
import {ModalControllerService} from '../../../../shared/shared-services/overlay/modal-controller.service';
import {IconsEnum} from '../../../shared-icons/models/icons.enum';
import {IconColourEnum} from '../../../shared-icons/models/icons-colour.enum';

@Component({
  selector: 'app-basic-multiple-input',
  templateUrl: './basic-multiple-input.component.html',
  styleUrls: ['./basic-multiple-input.component.scss'],
  standalone: false,
})
export class BasicMultipleInputComponent implements OnInit {

  @Input() options: GetInputAlertOptions;
  emailForm: UntypedFormGroup;

  formControl: UntypedFormControl;
  icons = IconsEnum;
  iconColourEnum = IconColourEnum;

  constructor(
    private modalController: ModalControllerService,
  ) {
  }

  get emailFormArray(): FormArray {
    return this.emailForm.get('emails') as FormArray;
  }

  ngOnInit(): void {
    const validators: ValidatorFn[] = [Validators.required];

    if (this.options.pattern) {
      validators.push(Validators.pattern(this.options.pattern));
    }

    if (this.options.validators) {
      validators.push(...this.options.validators);
    }

    if (this.options.type === 'number') {
      this.formControl = new FormControl<number>(null, validators);
    } else {
      this.formControl = new FormControl<string>(null, validators);
    }
    this.emailForm = new FormGroup({
      emails: new FormArray([]),
    });
    this.addEmail();
  }

  submit = async (): Promise<void> => {
    if (this.emailForm.invalid) return;
    const emails = this.emailForm.value.emails;
    await this.modalController.dismiss(emails).then();
  };

  cancel = (): void => {
    void this.modalController.dismiss(null).then();
  };

  getEmailFormControl(index: number): FormControl {
    return this.emailFormArray.at(index) as FormControl;
  }

  addEmail(): void {
    const validators = [Validators.required, nodemailerEmailValidator];
    this.emailFormArray.push(new FormControl('', validators));
  }

  removeEmail(): void {
    const index = this.emailFormArray.length - 1;
    if (index > 0) {
      this.emailFormArray.removeAt(index);
    }
  }

}
